'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.initAxios = initAxios;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _humps = require('humps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initAxios() {
  _axios2.default.defaults.withCredentials = true;
  _axios2.default.defaults.transformResponse = function (data, header) {
    if (header['content-type'] && header['content-type'].indexOf('application/json') > -1) {
      try {
        return (0, _humps.camelizeKeys)(JSON.parse(data));
      } catch (ex) {
        return (0, _humps.camelizeKeys)(data);
      }
    }
    return data;
  };

  _axios2.default.defaults.transformRequest = function (data) {
    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !(data instanceof FormData)) {
      return JSON.stringify((0, _humps.pascalizeKeys)(data));
    }
    return data;
  };
  _axios2.default.defaults.responseType = 'json';
  _axios2.default.defaults.headers.post['Content-Type'] = 'application/json';
  _axios2.default.defaults.headers.put['Content-Type'] = 'application/json';
  _axios2.default.defaults.headers.delete['Content-Type'] = 'application/json';
}

exports.default = { initAxios: initAxios };


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/login-pass/lib/helper/InitialHelper.js
 ** module id = 2256
 ** module chunks = 30 33 69 71
 **/